import React from 'react';
import PropTypes from 'prop-types';

import useStartPowerCheckout from '../../../hooks/useStartPowerCheckout';
import { PowerFunnelSurfaces, PowerFunnelGatedFeatures } from '../../../Analytics/constants';
import SavedListsBenefitsPanel from '../SavedListsBenefitsPanel';
import { POWER_CTA_LABEL } from '../constants';
import styles from './savedListsFreeUpsell.scss';

const HEADING = 'Upgrade to Power to unlock Saved Lists';

const SavedListsFreeUpsell = ({ 'data-testid': dataTestId, showPreview }) => {
    const { startPowerCheckout } = useStartPowerCheckout();

    // Reuses the global header GET POWER funnel; a successful upgrade flips the tab to the Power view
    // via the power-upgrade-success refetch in useSavedPlayerLists.
    const handleGetPower = () => {
        startPowerCheckout({
            surface: PowerFunnelSurfaces.PLAYER_PROFILE,
            gatedFeature: PowerFunnelGatedFeatures.SAVED_PLAYER_LIST,
        });
    };

    return (
        <SavedListsBenefitsPanel
            data-testid={dataTestId}
            heading={HEADING}
            showPreview={showPreview}
            panelClassName={styles.panel}
            previewClassName={styles.preview}
        >
            <button
                type="button"
                className={styles.getPowerBtn}
                onClick={handleGetPower}
                data-testid={dataTestId && `${dataTestId}.get-power-btn`}
            >
                {POWER_CTA_LABEL}
            </button>
        </SavedListsBenefitsPanel>
    );
};

SavedListsFreeUpsell.propTypes = {
    'data-testid': PropTypes.string,
    showPreview: PropTypes.bool,
};

SavedListsFreeUpsell.defaultProps = {
    'data-testid': null,
    showPreview: true,
};

export default SavedListsFreeUpsell;
